import { render, staticRenderFns } from "./v-ship-dept.vue?vue&type=template&id=544b4420&scoped=true&"
import script from "./v-ship-dept.vue?vue&type=script&lang=js&"
export * from "./v-ship-dept.vue?vue&type=script&lang=js&"
import style0 from "./v-ship-dept.vue?vue&type=style&index=0&id=544b4420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544b4420",
  null
  
)

export default component.exports